import { render, staticRenderFns } from "./addLinkModal.vue?vue&type=template&id=4a490ecb&scoped=true"
import script from "./addLinkModal.vue?vue&type=script&lang=js"
export * from "./addLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a490ecb",
  null
  
)

export default component.exports